// extracted by mini-css-extract-plugin
export var container = "about-module--container--PNnX9";
export var containerLeft = "about-module--containerLeft--uF6hI";
export var containerRight = "about-module--containerRight--4LZgJ";
export var containerSubtitle = "about-module--containerSubtitle--6DQ4X";
export var containerText = "about-module--containerText--nubQ7";
export var donation = "about-module--donation--yq9bG";